import authGuard from './auth.guard';
import guestGuard from './guest.guard';
import accessGuard from './access.guard';
import operationGuard from './operationType.guard';

const guards = {
  authGuard,
  guestGuard,
  accessGuard,
  operationGuard,
};

export default guards;